import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-procedures-detail',
  templateUrl: './procedures-detail.component.html',
  styleUrls: ['./procedures-detail.component.scss']
})
export class ProceduresDetailComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ProceduresDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { detail: string } ) { }

  ngOnInit(): void { }

  onClose(): void {
    this.dialogRef.close();
  }
}
